module.exports = __webpack_public_path__ + "fonts/b9b69c62ec91497384a95788dc82532b.9765aeac.ttf";